import Vue from 'vue'
import Vuex from 'vuex'
//import createPersistedState from "vuex-persistedstate";

// Load Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    active: 0,
    api_status: "",
    databaseExported: false,
    authenticated: false,
    invertersList: null,
    searchInvertersList: null,
    invertersListBool: [],
    invertersResponse: "",
    optimizersList: null,
    searchOptimizersList: null,
    optimizersListBool: [],
    optimizersResponse: "",
    modulesList: null,
    searchModulesList: null,
    modulesListBool: [],
    modulesResponse: "",
    batteriesList: null,
    searchBatteriesList: null,
    batteriesListBool: [],
    batteriesResponse: "",
    cablesList: null,
    searchCablesList: null,
    cablesListBool: [],
    cablesResponse: "",
    metersList: null,
    searchMetersList: null,
    metersListBool: [],
    metersResponse: "",
    smaStorageList: null,
    searchSmaStorageList: null,
    smaStorageListBool: [],
    smaStorageResponse: "",
    usersList: null,
    searchUsersList: null,
    usersListBool: [],
    usersResponse: "",
    authenticatedAdmin: false,
    axios_error: null,
    InvertersHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "EXTENSION_REFERENCE", value: "EXTENSION_REFERENCE" },
      { text: "EXTENSION_QUANTITY", value: "EXTENSION_QUANTITY" },
      { text: "DESC_NL", value: "DESC_NL" },
      { text: 'DESC_FR', value: "DESC_FR" },
      { text: "SOG_TYPE", value: "SOG_TYPE" },
      { text: "POWER", value: "POWER" },
      { text: "PHASES", value: "PHASES" },
      { text: "DELTA_COMPATIBLE", value: "DELTA_COMPATIBLE" },
      { text: "EXTENDED", value: "EXTENDED" },
      { text: "STOREDGE", value: "STOREDGE" },
      { text: "EV", value: "EV" },
      { text: "STRING_INPUTS", value: "STRING_INPUTS" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    OptimizersHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "MANUFACTURER", value: "MANUFACTURER" },
      { text: "POWER", value: "POWER" },
      { text: "ALIAS", value: "SOG_TYPE" },
      { text: 'OPTIMIZATION', value: "OPTIMIZATION" },
      { text: "SAFETY", value: "SAFETY" },
      { text: "MONITORING", value: "MONITORING" },
      { text: "GATEWAY", value: "GATEWAY" },
      { text: "CLOUD_CONNECT", value: "CLOUD_CONNECT" },
      { text: "INSTALLATION", value: "INSTALLATION" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    BatteriesHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "BATTERY_MODULE", value: "BATTERY_MODULE" },
      { text: "DESC_NL", value: "DESC_NL" },
      { text: 'DESC_FR', value: "DESC_FR" },
      { text: "TYPE", value: "TYPE" },
      { text: "COMPATIBILITY", value: "COMPATIBILITY" },
      { text: "ACCESSORIES", value: "ACCESSORIES" },
      { text: "BATTERY_ID", value: "BATTERY_ID" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    ModulesHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "Reference", value: "Reference" },
      { text: "Manufacturer", value: "Manufacturer" },
      { text: "Manufacturer_ID", value: "Manufacturer_ID" },
      { text: "ModuleId", value: "ModuleId" },
      { text: 'Name', value: "Name" },
      { text: "PModMPP", value: "PModMPP" },
      { text: "CellType", value: "CellType" },
      { text: "FullBlack", value: "FullBlack" },
      { text: "Bisun", value: "Bisun" },
      { text: "optimizer", value: "optimizer" },
      { text: "MaleConnector", value: "MaleConnector" },
      { text: "FemaleConnector", value: "FemaleConnector" },
      { text: "YmaleConnector", value: "YmaleConnector" },
      { text: "YfemaleConnector", value: "YfemaleConnector" },
      { text: "mc4FuseType", value: "mc4FuseType" },
      { text: "ModuleAlias1", value: "ModuleAlias1" },
      { text: "ModuleAlias2", value: "ModuleAlias2" },
      { text: "ModuleAlias3", value: "ModuleAlias3" },
      { text: "ModuleAlias4", value: "ModuleAlias4" },
      { text: "ModuleAlias5", value: "ModuleAlias5" },
      { text: "Copy/Edit/Delete", value: "actions", sortable: false },
    ],
    CablesHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "DESC_NL", value: "DESC_NL" },
      { text: 'DESC_FR', value: "DESC_FR" },
      { text: "TYPE", value: "TYPE" },
      { text: 'SECTION', value: "SECTION" },
      { text: "LENGTH", value: "LENGTH" },
      { text: "CONNECTORS", value: "CONNECTORS" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    SmaStorageHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "SYSTEM_ID", value: "SYSTEM_ID" },
      { text: "DESC_NL", value: "DESC_NL" },
      { text: 'DESC_FR', value: "DESC_FR" },
      { text: "TYPE", value: "TYPE" },
      { text: 'QUANTITY', value: "QUANTITY" },
      { text: "DC_CURRENT", value: "DC_CURRENT" },
      { text: "DC_CABLE", value: "DC_CABLE" },
      { text: "FAMILY", value: "FAMILY" },
      { text: "ACCESSORIES_PB", value: "ACCESSORIES_PB" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    MetersHeaders: [
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
      { text: "REFERENCE", value: "REFERENCE" },
      { text: "DESC_NL", value: "DESC_NL" },
      { text: 'DESC_FR', value: "DESC_FR" },
      { text: "TYPE", value: "TYPE" },
      { text: 'COMPATIBILITY', value: "COMPATIBILITY" },
      { text: "CT", value: "CT" },
      { text: "CT_NUMBER", value: "CT_NUMBER" },
      { text: "I_MAX", value: "I_MAX" },
      { text: "COPY/EDIT/DELETE", value: "actions", sortable: false },
    ],
    UsersHeaders: [
      { text: "Nom", value: "NOM" },
      { text: "Prenom", value: "PRENOM" },
      { text: "email", value: "EMAIL" },
      { text: "Admin", align: "end", value: "ADMIN" },
      { text: "EDIT/DELETE", value: "actions", sortable: false },
    ],
    selected: [],
    errorMessages: '',
    invertersEditedItem: {
      REFERENCE: '',
      EXTENSION_REFERENCE: '',
      EXTENSION_QUANTITY: '',
      DESC_NL: '',
      DESC_FR: '',
      SOG_TYPE: '',
      POWER: '',
      PHASES: 1,
      DELTA_COMPATIBLE: false,
      EXTENDED: false,
      STOREDGE: false,
      EV: false,
      STRING_INPUTS: 0,
    },
    optimizersEditedItem: {
      REFERENCE: '',
      MANUFACTURER: '',
      POWER: '',
      SOG_TYPE: '',
      OPTIMIZATION: false,
      SAFETY: false,
      MONITORING: false,
      GATEWAY: false,
      CLOUD_CONNECT: false,
      INSTALLATION: '',
    },
    modulesEditedItem: {
      Reference: '',
      Manufacturer: '',
      Manufacturer_ID: '',
      ModuleId: '',
      Name: '',
      PModMPP: 0,
      CellType: '',
      FullBlack: false,
      Bisun: false,
      optimizer: false,
      STOREDGE: false,
      MaleConnector: '',
      FemaleConnector: '',
      YmaleConnector: '',
      YfemaleConnector: '',
      mc4FuseType: '',
      ModuleAlias1: '',
      ModuleAlias2: '',
      ModuleAlias3: '',
      ModuleAlias4: '',
      ModuleAlias5: '',
    },
    batteriesEditedItem: {
      REFERENCE: '',
      BATTERY_MODULE: '',
      DESC_NL: '',
      DESC_FR: '',
      TYPE: '',
      COMPATIBILITY: '',
      ACCESSORIES: '',
      BATTERY_ID: '',
    },
    cablesEditedItem: {
      REFERENCE: '',
      DESC_NL: '',
      DESC_FR: '',
      TYPE: '',
      SECTION: '',
      LENGTH: 0,
      CONNECTORS: '',
    },
    metersEditedItem: {
      REFERENCE: '',
      DESC_NL: '',
      DESC_FR: '',
      TYPE: '',
      COMPATIBILITY: '',
      CT: '',
      CT_NUMBER: 0,
      I_MAX: 0,
    },
    smaStorageEditedItem: {
      REFERENCE: '',
      SYSTEM_ID: '',
      DESC_NL: '',
      DESC_FR: '',
      TYPE: '',
      QUANTITY: 0,
      DC_CURRENT: 0,
      DC_CABLE: 0,
      FAMILY: '',
      ACCESSORIES_PB: '',
    },
    usersEditedItem: {
      NOM: '',
      PRENOM: '',
      EMAIL: '',
      ADMIN: false
    },
},
  mutations: {
  },
  actions: {
  },
  //plugins: [createPersistedState()]
})

